import { Motive } from '../../../../../shared/types/systemConfiguration/motives';

export const initialValues: Motive = {
    name: '',
    parent: [],
    active: true,
};
